import { render, staticRenderFns } from "./instructionEdit.vue?vue&type=template&id=64695b01&scoped=true&"
import script from "./instructionEdit.vue?vue&type=script&lang=js&"
export * from "./instructionEdit.vue?vue&type=script&lang=js&"
import style0 from "./instructionEdit.vue?vue&type=style&index=0&id=64695b01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64695b01",
  null
  
)

export default component.exports